// src/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * ProtectedRoute component that checks for authentication.
 * If user is not logged in, redirects to /login and saves the intended destination.
 * After login, user will be redirected back to their original destination.
 */
function ProtectedRoute({ children }) {
  const location = useLocation();
  const token = localStorage.getItem('managerToken');
  const userStr = localStorage.getItem('managerUser');

  // Check if user is authenticated
  let isAuthenticated = false;
  if (token && userStr) {
    try {
      const user = JSON.parse(userStr);
      isAuthenticated = !!user;
    } catch (err) {
      console.error('Error parsing user data:', err);
    }
  }

  if (!isAuthenticated) {
    // Save the full path including search params (e.g., ?issue=m91mbhazOg)
    const intendedPath = location.pathname + location.search;
    
    // Store the intended destination in sessionStorage
    // Using sessionStorage so it clears when browser is closed
    sessionStorage.setItem('redirectAfterLogin', intendedPath);
    
    console.log('Not authenticated, redirecting to login. Will return to:', intendedPath);
    
    // Redirect to login page
    return <Navigate to="/login" replace />;
  }

  // User is authenticated, render the protected content
  return children;
}

export default ProtectedRoute;

